import React from 'react'


const RadioButton = props => {

	const {
		children,
		direction = "_row"
	} = props

	return (
		<div className={`radioButton ${direction}`}>
			{children}
		</div>
	)

}


export default RadioButton
